import { render, staticRenderFns } from "./documentCard.vue?vue&type=template&id=788ce942&scoped=true&"
import script from "./documentCard.vue?vue&type=script&lang=js&"
export * from "./documentCard.vue?vue&type=script&lang=js&"
import style0 from "./documentCard.vue?vue&type=style&index=0&id=788ce942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788ce942",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('788ce942')) {
      api.createRecord('788ce942', component.options)
    } else {
      api.reload('788ce942', component.options)
    }
    module.hot.accept("./documentCard.vue?vue&type=template&id=788ce942&scoped=true&", function () {
      api.rerender('788ce942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/documents/documentCard.vue"
export default component.exports